import { InformationHoverIcon } from "./InformationHoverIcon";

type LeadCategory = {
  label: string;
  count: number;
  percentage: number;
};

type Props = {
  totalLeads: number;
  categories: LeadCategory[];
};

const ProgressBar = ({ value, label }: { value: number; label: string }) => (
  <div className="relative h-8 w-full overflow-hidden rounded-full bg-gray-200">
    <div
      className="h-full rounded-full bg-purple-600 transition-all duration-300"
      style={{ width: `${Math.max(value, 0)}%` }}
    />
    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-medium text-white">
      {label}
    </span>
  </div>
);

const LeadCategoriesChart = ({ totalLeads, categories }: Props) => {
  return (
    <div className="rounded-lg border border-[#e2e8f0] bg-white p-6 shadow-sm">
      {/* Header */}
      <div className="mb-6 flex items-center gap-2">
        <p className="text-lg font-semibold text-gray-800">Tipo de cliente</p>
        <InformationHoverIcon information="Muestra cómo se distribuyen los leads según el tiempo que falta para su mudanza. Cada categoría representa un rango de días específico." />
      </div>

      {/* Total Bar */}
      <div className="mb-4 flex items-center">
        <div className="min-w-[120px]">
          <p className="font-medium text-gray-800">Total</p>
        </div>
        <div className="mx-4 flex-1">
          <ProgressBar value={100} label="Total: 100%" />
        </div>
        <div className="min-w-[40px] text-right">
          <p className="font-semibold text-gray-800">{totalLeads}</p>
        </div>
      </div>

      {/* Category Bars */}
      {categories.map((category) => (
        <div key={category.label} className="mb-4 flex items-center">
          <div className="min-w-[120px]">
            <p className="text-gray-800">{category.label}</p>
          </div>
          <div className="mx-4 flex-1">
            <ProgressBar value={category.percentage} label={`${category.percentage}%`} />
          </div>
          <div className="min-w-[40px] text-right">
            <p className="font-semibold text-gray-800">{category.count}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeadCategoriesChart;
